import { TranslateableText, Translator } from '../../i18n'

import { useFormProgram } from './useFormProgram'

export const useGetText = (text: TranslateableText.TranslateableText) =>
  useFormProgram(Translator.getText(text))
